import React, { useRef } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Topbar from './Topbar'
import useResponsiveTables from './components/useResponsiveTables'
import './responsive-tables.css'

// Shell follows rock-dashboard src/layouts/MainLayout.js (Tabler page layout).
function Portal() {
  const contentRef = useRef(null);
  useResponsiveTables(contentRef);

  return (
    <div className="page app-shell">
      <Sidebar />
      <div className="page-wrapper">
        <Topbar />
        <div className="page-body">
          <div id="content" className="container-fluid" ref={contentRef}>
            <Outlet></Outlet>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Portal
